import { const_var, params } from "../../redux/reducers/reducer";
import { calcOverhangSize } from "../building_component/buildingComponent.helper";

export const selectOverhangBOBCase = (state,compare,other) => {
	let msn = compare == true ? const_var.editAPIDataByResponse?.data?.request_data?.building.manufacturer : params.m_s_n
	if(msn == '122' ||  other == true){
		let options = compare != true ? const_var.a_p_d_a : const_var.editAPIDataByResponse.data.pricing_data
		let endOverhangIndex =  options?.extra_items?.[0].checkbox.length ?? 0;
		let sideOverhangIndex = options?.overhang?.side?.length > 0 ? endOverhangIndex + 1 : (options?.extra_items?.[0].checkbox?.length ?? 0);
		let bothOverhangIndex = options?.overhang?.both != '' ? options?.extra_items?.[0]?.checkbox?.length : 0;
	
		if(compare == true){
			const_var.ExtraItemsFeaturesArray = Object.values(const_var.ExtraItemsFeaturesArray).map((item) => {
				if(item?.name != undefined && item?.name != "overhang"){
					return item
				}
			})
		}
		
		let both = true
		let side = true
		let end = true
		if(other == true){
			if(const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g == false && const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g_e == false){
				both = false
			}else{
				if(const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g == false){
					side = false
				}
				if(const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g_e == false){
					end = false
				}
			}
		}

		if(options?.overhang?.both != undefined && options?.overhang?.both != '' && both == true){
		

			let item = options?.overhang?.both
			item['is_checked'] = true
		
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex] = item
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['cost'] = /* other != true ? 0 : */ item.cost
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['cost_type'] = item.cost_type 
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['is_checked'] = true 
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['is_edit'] = false 
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['label'] = item.sheet_name == undefined ? "1' Overhang" :  item.sheet_name
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['length'] = item.length
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['name'] = "overhang"
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['price_of'] = item.price_of 
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['sheet_name'] = item.sheet_name == undefined ? "1' Overhang" : item.sheet_name
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['sheet_type'] = item.sheet_type == undefined ? "both" : item.sheet_type  
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['width'] = item.width
			const_var.ExtraItemsFeaturesArray[bothOverhangIndex]['quantity'] = "1"
			
			if(compare == true){
				const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g= true
				const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g_e= true
				const_var.editAPIDataByResponse.data.request_data.building.overhang['both']['selected'] = item.sheet_name;
				let size = calcOverhangSize(item.sheet_name)
				
				const_var.editAPIDataByResponse.data.request_data.building.overhang['end']['size'] = size != "" ? size : 1
				const_var.editAPIDataByResponse.data.request_data.building.overhang['side']['size'] = size != "" ? size : 1
				const_var.editAPIDataByResponse.data.request_data.building.overhang['both']['size'] = size != "" ? size : 1
	
				const_var.editAPIDataByResponse.data.request_data.building.overhang['both']['selected'] = ''
				const_var.editAPIDataByResponse.data.request_data.building.overhang['side']['selected'] = ''
				const_var.editAPIDataByResponse.data.request_data.building.overhang['end']['selected'] = ''
			}else{
				state.params.o_v_h_n_g = true
				state.params.o_v_h_n_g_e = true
				state.const_var.isOverhang['both']['selected'] = item.sheet_name;
				// state.const_var.isOverhang['both']['item_price'] = 0;
				let size = calcOverhangSize(item.sheet_name)
				// state.const_var.isOverhang['end']['selected']['item_price'] = 0;
				// state.const_var.isOverhang['side']['selected']['item_price'] = 0;
				state.const_var.isOverhang['end']['size'] = size != "" ? size : 1
				state.const_var.isOverhang['side']['size'] = size != "" ? size : 1
				state.const_var.isOverhang['both']['size'] = size != "" ? size : 1
	
				state.const_var.isOverhang['both']['selected'] = ''
				state.const_var.isOverhang['side']['selected'] = ''
				state.const_var.isOverhang['end']['selected'] = ''
			}
		}else{
			if(options?.overhang?.end?.length > 0 && end == true){
			
				options.overhang.end.forEach((item, index) => {
					if(index == 0){
						item['is_checked'] = true
						item['cost'] = /* other != true ? 0 : */ item.cost

						if(compare == true){
							const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g_e= true
							const_var.editAPIDataByResponse.data.request_data.building.overhang['end']['selected'] = item.sheet_name;
							let size = calcOverhangSize(item.sheet_name)
							const_var.editAPIDataByResponse.data.request_data.building.overhang['end']['size'] = size != "" ? size : 1
						}else{
							state.params.o_v_h_n_g_e = true
							state.const_var.isOverhang['end']['selected'] = item.sheet_name;
							let size = calcOverhangSize(item.sheet_name)
							state.const_var.isOverhang['end']['size'] = size != "" ? size : 1
						}
					}
				})
			}
			if(options?.overhang?.side?.length > 0 && side == true){
				
				options.overhang.side.forEach((item, index) => {
					if(index == 0){
						item['is_checked'] = true
					
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex] = item
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['cost'] = /* other != true ? 0 : */ item.cost
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['cost_type'] = item.cost_type 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['id'] = item.id 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['is_checked'] = true 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['is_edit'] = false 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['is_included'] = item.is_included 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['label'] = item.sheet_name
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['length'] = item.length
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['map_id'] = item.map_id 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['name'] = "overhang"
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['price_of'] = item.price_of 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['quantity'] = item.quantity 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['sheet_name'] = item.sheet_name 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['sheet_type'] = item.sheet_type 
						const_var.ExtraItemsFeaturesArray[sideOverhangIndex]['width'] = item.width

						if(compare == true){
							const_var.editAPIDataByResponse.data.paramsData.o_v_h_n_g= true
							const_var.editAPIDataByResponse.data.request_data.building.overhang['side']['selected'] = item.sheet_name;
							let size = calcOverhangSize(item.sheet_name)
							const_var.editAPIDataByResponse.data.request_data.building.overhang['side']['size'] = size != "" ? size : 1
						}else{
							state.params.o_v_h_n_g = true
							state.const_var.isOverhang['side']['selected'] = item.sheet_name;
							let size = calcOverhangSize(item.sheet_name)
							state.const_var.isOverhang['side']['size'] = size != "" ? size : 1
						}
					}
				})
			}
		}
	}
}

export const setZeroPriceOverhang = (response) => {
	if (response.overhang) {
		if (response.overhang.end?.length > 0) {
			response.overhang.end.forEach((item) => {
				if (item.is_included != undefined && item.is_included == 1) {
				}
			});
		}
		if (response.overhang.side?.length > 0) {
			response.overhang.side.forEach((item) => {
				if (item.is_included != undefined && item.is_included == 1) {
				}
			});
		}
	}
};
export const updateOverhangOnLeanUpdate = (leanType, state, a_p_d_a) => {
	if (leanType === "centerBuilding") {
	} else if (!params[`add_${leanType}_lean`]) {
		return;
	}

	let forCB = false;
	let ExtraItemsFeaturesArray = [];
	if (const_var.isLTBuilding) {
		ExtraItemsFeaturesArray = const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding;
		if (leanType === "centerBuilding") {
			forCB = true;
			const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType] = const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding;
		}
	} else {
		if (leanType === "centerBuilding") {
			forCB = true;
			const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType] = JSON.parse(JSON.stringify(const_var.ExtraItemsFeaturesArray ?? []));
		}

		ExtraItemsFeaturesArray = JSON.parse(JSON.stringify(const_var.ExtraItemsFeaturesArray ?? []));
	}

	ExtraItemsFeaturesArray.forEach((extraItem, valIndex) => {
		if (extraItem?.name === "overhang") {
			if (extraItem.sheet_type == "both" && extraItem.is_edit == false) {
				const aIndex = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType].findIndex((item) => {
					if (item?.cost_type) {
						return item.sheet_type === "both";
					}
					return false;
				});
				const doBothOverhangExistInThisBuilding = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][aIndex];
				let overhang = null;

				if (doBothOverhangExistInThisBuilding) {
					const d = a_p_d_a.overhang != "" && a_p_d_a.overhang && Object.entries(a_p_d_a.overhang)?.find(([key, value]) => key === "both" && value?.cost > 0);
					if (d && Array.isArray(d) && d.length > 0 && d[1]?.cost_type) {
						overhang = d[1];
						const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][aIndex] = {
							...doBothOverhangExistInThisBuilding,
							...overhang
						};
					}

					if (!d || !d[1]) {
						const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType].splice(aIndex, 1);
					}
				} else {
					const d = a_p_d_a.overhang != "" && a_p_d_a.overhang && Object.entries(a_p_d_a.overhang)?.find(([key, value]) => key === "both" && value?.cost > 0);

					if (d && Array.isArray(d) && d.length > 0 && d[1]?.cost_type) {
						overhang = d[1];
						overhang.label = extraItem.label;
						overhang.name = extraItem.name;
						overhang.is_edit = extraItem.is_edit;
						overhang.is_checked = extraItem.is_checked;
						if (overhang.sheet_name) {
							overhang.sheet_name = extraItem.sheet_name;
						}
						if (overhang.sheet_type) {
							overhang.sheet_type = extraItem.sheet_type;
						}
						const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][valIndex] = overhang;
						if (forCB) {
							state.const_var.extraItemsFeaturesCost[valIndex] = overhang.cost;
						}
					}
				}
			} else {
				const aIndex = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType].findIndex((item) => {
					if (item?.cost_type) {
						return item.sheet_type === extraItem.sheet_type;
					}
					return false;
				});
				const doSideEndOverhangExistInThisBuilding = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][aIndex];
				if (doSideEndOverhangExistInThisBuilding) {
					const d = a_p_d_a.overhang != "" && a_p_d_a.overhang && Object.entries(a_p_d_a.overhang)?.find(([key, value]) => key === extraItem.sheet_type);
					if (d && Array.isArray(d) && d.length > 0 && d[1]) {
						let overhang = null;

						let apda_overhang = (a_p_d_a.overhang != "" && a_p_d_a.overhang && Object.entries(a_p_d_a.overhang)) ?? [];

						apda_overhang.forEach(([key, value]) => {
							if (overhang?.cost_type || key !== extraItem.sheet_type) {
								return;
							}

							if (value != "" && value?.length == 0 && value["sheet_name"] != undefined) {
								overhang = value;
							}

							if (value && value?.length > 0 && value[0] != undefined) {
								let found = null;

								if (extraItem.sheet_name) {
									found = value.find((overItem) => extraItem.sheet_name == overItem.sheet_name || extraItem.id === overItem.id);
								}

								if (!found && extraItem.sheet_type) {
									const overhangSize = const_var.isOverhang[extraItem.sheet_type]["size"];
									found = value.find((overItem) => overItem?.sheet_name?.includes(overhangSize));
								}

								if (!found) {
									found = value[0];
								}

								if (found?.cost_type) {
									overhang = found;
								}
							}
						});

						if (overhang?.cost_type) {
							overhang.label = extraItem.label;
							overhang.name = extraItem.name;
							overhang.is_edit = extraItem.is_edit;
							overhang.is_checked = extraItem.is_checked;
							const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][aIndex] = overhang;
							if (forCB) {
								state.const_var.extraItemsFeaturesCost[valIndex] = overhang.cost;
							}
						}
					} else {
						const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType].splice(aIndex, 1);
					}
				} else {
					let overhang = null;

					let apda_overhang = (a_p_d_a.overhang != "" && a_p_d_a.overhang && Object.entries(a_p_d_a.overhang)) ?? [];

					apda_overhang.forEach(([key, value]) => {
						if (overhang?.cost_type || key !== extraItem.sheet_type) {
							return;
						}

						if (value != "" && value?.length == 0 && value["sheet_name"] != undefined) {
							overhang = value;
						}

						if (value && value?.length > 0 && value[0] != undefined) {
							let found = null;

							if (extraItem.sheet_name) {
								found = value.find((overItem) => extraItem.sheet_name == overItem.sheet_name || extraItem.id === overItem.id);
							}

							if (!found && extraItem.sheet_type) {
								const overhangSize = const_var.isOverhang[extraItem.sheet_type]["size"];
								found = value.find((overItem) => overItem?.sheet_name?.includes(overhangSize));
							}

							if (!found) {
								found = value[0];
							}

							if (found?.cost_type) {
								overhang = found;
							}
						}
					});

					if (overhang?.cost_type) {
						overhang.label = extraItem.label;
						overhang.name = extraItem.name;
						overhang.is_edit = extraItem.is_edit;
						overhang.is_checked = extraItem.is_checked;
						const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType][valIndex] = overhang;
						if (forCB) {
							state.const_var.extraItemsFeaturesCost[valIndex] = overhang.cost;
						}
					}
				}
			}
		}
	});

	if (const_var.isLTBuilding) {
		if (leanType === "centerBuilding") {
			const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType];
		}
		state.const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding = const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding;
	} else {
		if (leanType === "centerBuilding") {
			const_var.ExtraItemsFeaturesArray = JSON.parse(JSON.stringify(const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation[leanType] ?? []));
		}
		state.const_var.ExtraItemsFeaturesArray = const_var.ExtraItemsFeaturesArray;
	}

	state.const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation = const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation;
};
export const calcLeantoOverhangCost = (overhangData = undefined, leanData) => {
	let leanCost = 0;
	if (overhangData == "both") {
		leanData.map((leanItem) => {
			if (leanItem.pricing_data?.overhang && leanItem.pricing_data?.overhang[overhangData] && leanItem.pricing_data?.overhang && leanItem.pricing_data?.overhang[overhangData] != "") {
				leanCost = parseFloat(leanCost) + parseFloat(leanItem.pricing_data?.overhang[overhangData].cost);
			}
		});
	} else {
		leanData.map((leanItem) => {
			if (leanItem.pricing_data?.overhang && leanItem.pricing_data?.overhang[overhangData] && leanItem.pricing_data?.overhang && leanItem.pricing_data?.overhang[overhangData].length > 0) {
				leanCost = parseFloat(leanCost) + parseFloat(leanItem.pricing_data?.overhang[overhangData][0].cost);
			}
		});
	}
	return leanCost;
};
